/* unplugin-vue-components disabled */import script from "./TabbedModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabbedModal.vue?vue&type=script&lang=ts&setup=true"

import "./TabbedModal.vue?vue&type=style&index=0&id=16443702&lang=scss"

const __exports__ = script;

export default __exports__